import { Component, Inject, Input, NgModuleRef } from '@angular/core';
import { RbacPermissionsConstant } from '../../services/rbac/rbac-permissions.constant';
import { IMODALS_SERVICE, IModalsService } from '@platform500services/p500-ui-kit';
import { BaseTermsComponent } from '../../modals/base-terms/base-terms.component';
import { MetricTypesEnum } from '../../../modules/settings/terms/enums/metric-types.enum';
import { aggregateLocalization, formatLocalization, modelsLocalization } from './helpers/base-metrics.helpers';

export interface CardData {
  created_at_timestamp?: string;
  format: string;
  formula: string;
  icon: string;
  id?: number;
  name?: string;
  label?: string;
  model: string;
  filters?: { field: string; operator: string; values: string[] }[];
  aggregate: string;
  target: string;
  description: string;
  metric_type: MetricTypesEnum;
  key: string;
}

@Component({
  selector: 'gtd-base-metric-card',
  templateUrl: './base-metric-card.component.html',
})
export class BaseMetricCardComponent {
  @Input() public row: CardData;
  @Input() public viewOnly: boolean;
  public RbacPermissionsConstant = RbacPermissionsConstant;
  public modelLocalization = modelsLocalization;
  public aggregateLocalization = aggregateLocalization;
  public formatLocalization = formatLocalization;

  constructor(@Inject(IMODALS_SERVICE) public modalService: IModalsService, private ngRef: NgModuleRef<any>) {}

  edit(id: number) {
    this.modalService.open(BaseTermsComponent, { id }, this.ngRef);
  }
}
